<style lang="scss" type="text/scss" scoped>
  .form-item {
    position: relative;
    display: block;
    width: 100%;
    font-size: 14px;
    height: 34px;
    background-color: transparent;
  }

  .form-item .form-item-wrapper {
    width: 100%;
    zoom: 1;
    background-color: transparent;
    &:after {
      content: '.';
      font-size: 0;
      visibility: hidden;
      height: 0;
      width: 0;
      clear: both;
    }
  }

  .form-item .form-item__error {
    position: absolute;
    height: 30px;
    width: 350px;
    line-height: 30px;
    top: 0;
    font-size: 14px;
    img {
      display: block;
      margin-top: 8px;
      margin-right: 4px;
      margin-left: 10px;
      float: left;
      height: 15px;
      width: 15px;
    }
    span {
      display: block;
      width: 300px;
      float: left;
      color: red;
    }

  }

  .line__error {
    top: 30px;
    left: 0;
  }

  .form-item-title {
    float: left;
    height: 30px;
    line-height: 30px;
    padding-right: 20px;
    text-align: right;
    color: #333;
  }

  .form-item-value {
    /*border: 1px solid #a0a0a0;*/
    position: relative;
    height: 30px;
  }

  .form-item-value input, .form-item-value textarea {
    border: 1px solid #a0a0a0;
    width: 99.5%;
    height: 100%;
    padding-left: 4px;
    font-size: 14px;
    color: #5F5F5F;
  }

  .form-item-value textarea {
    width: 100%;
    height: 58px;
  }

</style>
<template>
  <div class="form-item" ref="formItem">
    <slot name="left"></slot>
    <div class="form-item-wrapper" :class="itemClassName">
      <div class="form-item-title" :style="labelStyle" v-show="label">
        <span class="mint-cell-text" v-html="label"></span>
      </div>
      <div class="form-item-value">
        <input v-if="type!== 'textarea'"
               class="mint-field-core"
               :type="type"
               :value="currentValue"
               :name="name"
               ref="input"
               :placeholder="placeholder"
               :disabled="disabled"
               :style="style"
               :readonly="readonly"
               :form="form"
               :rules="rules"
               :autofocus="autofocus"
               :maxlength="maxlength"
               :minlength="minlength"
               :class="className"
               :prop="prop"
               @input="handleInput"
               @focus="handleFocus"
               @blur="handleBlur"
               @click="handleClick"
               @change="handleChange"
               @touchend="handleTouchEnd"
               @touchstart="handleTouchStart"
        />
        <textarea v-else
                  class="mint-field-core"
                  :type="type"
                  :value="currentValue"
                  :name="name"
                  ref="input"
                  :placeholder="placeholder"
                  :disabled="disabled"
                  :style="style"
                  :readonly="readonly"
                  :form="form"
                  :rules="rules"
                  :autofocus="autofocus"
                  :maxlength="maxlength"
                  :minlength="minlength"
                  :class="className"
                  :prop="prop"
                  @input="handleInput"
                  @focus="handleFocus"
                  @blur="handleBlur"
                  @click="handleClick"
                  @change="handleChange"
                  @touchend="handleTouchEnd"
                  @touchstart="handleTouchStart"
                  :rows="row"
                  :cols="cols"
                  :wrap="wrap">
        </textarea>
        <slot name="right"></slot>
      </div>
    </div>
    <div class="form-item__error line__error" v-show="errorMeg || isError" ref="itemError">
      <img :src="formItemImg" alt="img"/>
      <span></span>
      <span v-text="errorMeg"></span>
    </div>
  </div>

</template>
<script>
  import mixin from './mixin'
  import wrong_03 from '../../assets/images/wrong_03.png'
  import success_01 from '../../assets/images/success_01.png'

  export default {
    name: 'HInput',
    componentName: 'HInput',
    props: {
      label: {
        type: String,
        default: ''
      },
      value: [String, Number],
      placeholder: String,
      className: String,
      readonly: Boolean,
      disabled: Boolean,
      type: {
        type: String,
        default: 'text'
      },
      prop: String,
      name: String,
      autoComplete: {
        type: String,
        default: 'off'
      },
      autofocus: Boolean,
      form: String,
      maxlength: Number,
      minlength: Number,
      rules: Object,
      row: {
        type: Number,
        default: 2
      },
      cols: {
        type: Number,
        default: 20
      },
      wrap: {
        type: String,
        default: 'hard'
      },
      labelWidth: {
        type: [String, Number]
      },
      line: {
        type: String,
        default: 'right'
      },
      sIcon:{
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        labelStyle: {},
        currentValue: this.value,
        style: {},
        CurrentEvents: [],
        valid: true,
        errorMeg: '',
        itemClassName: '',
        formItemImg: wrong_03,
        isError: false
      }
    },
    mixins: [mixin],
    methods: {
      //vue component 注册事件 start

      // @input 事件触发更新 value
      handleInput(event) {
        this.updateValue(event.target.value);
      },
      updateValue(value) {
        if(value !== this.currentValue) {
          this.currentValue = value;
          this.$emit('input', value);
          this.$emit('change', value);
        }
      },
      handleFocus(event) {
        this.$emit('focus', event);
      },
      handleChange(event) {
        this.$emit('change', event);
      },
      handleBlur(event) {
        this.$emit('blur', event);
      },
      handleClick(event) {
        this.$emit('click', event);
      },
      handleTouchEnd(event) {
        this.$emit('touchend', event);
      },
      handleTouchStart(event) {
        this.$emit('touchstart', event);
      },
      //vue component 注册事件 end

      // 设置label宽度等...
      formProps(component) {
        if(component.$parent && component.$parent.$options.componentName === "HForm") {
          let labelWidth = component.$parent.labelWidth || this.labelWidth;
          let type = component.$parent.type;
          if(labelWidth) {
            this.labelStyle = {
              width: labelWidth
            };
          }
          if(type) {
            this.itemClassName = 'form-item-wrapper-margin'
          }

        } else if(component.$parent) {
          this.formProps(component.$parent)
        }
      }
    },
    watch: {
      'value'(val, oldVal) {
        this.updateValue(val)
      },
      errorMeg(n, o) {
        if(n !== '') {
          this.isError = false;
        }
      },
      isError(n, o) {
        if(this.errorMeg === '' && n && this.sIcon) {
          this.formItemImg = success_01;
        } else {
          this.isError = false;
          this.formItemImg = wrong_03;
        }
      }
    },
    mounted() {
      this.currentValue = this.value;
      this.formProps(this);
      this.dispatchRules();
      this.$nextTick(() => {
        let f = this.$refs.formItem;
        let e = this.$refs.itemError;
        if (!e) {
          return;
        }
        if(this.line === 'right') {
          e.style.left = f.offsetWidth + 'px';
          let l = this.$el.querySelector('.form-item-title'), t = this.$el.querySelector('.form-item-value');
          t.style.marginLeft = l.offsetWidth + 'px';
        } else if(this.line === 'bottom') {
          e.style.top = f.offsetHeight + 'px';
          let l = this.$el.querySelector('.form-item-title'), t = this.$el.querySelector('.form-item-value');
          t.style.marginLeft = l.offsetWidth + 'px';
          e.style.left = l.offsetWidth - 8 + 'px';
        }

      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Form/HInput.vue